import { clsx } from 'clsx'
import { useSyncExternalStore } from 'react'
import { useI18n } from '@/i18n/i18n'
import { useBoardCtx } from './context'

/**
 * The change view drawn over the board (DESIGN.md 信任層): a ring around each
 * thing a turn added or changed, and a ghost where a removed thing was.
 * Board coordinates; never interactive, never part of the board.
 */
export function ChangeOverlay() {
  const { overlay } = useBoardCtx()
  const { t } = useI18n()
  const marks = useSyncExternalStore(overlay.subscribe, overlay.getSnapshot)
  if (!marks.length) return null
  const replaying = marks.some((m) => m.current)
  return (
    <>
      {marks.map((m) => (
        <div
          key={m.id}
          aria-hidden
          data-change-mark={m.status}
          className={clsx(
            'moot-change-mark',
            `is-${m.status}`,
            m.current && 'is-current',
            replaying && !m.current && 'is-dim',
          )}
          style={{
            transform: `translate(${m.rect.x}px, ${m.rect.y}px)`,
            width: m.rect.w,
            height: m.rect.h,
          }}
        >
          {m.status === 'removed' && (
            <span className="moot-change-ghost-label">
              {t('change.removedGhost', { label: m.label || t('change.anItem') })}
            </span>
          )}
        </div>
      ))}
    </>
  )
}
